module.exports = __webpack_public_path__ + "img/gb13871-92_75x100x10.prt.c06b6870.jpg";